import { createFileRoute } from '@tanstack/react-router'
import { AlternativesPage, alternativesHead, type AlternativesData } from '@/components/alternatives-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data: AlternativesData = {
  tool: "HetrixTools",
  slug: "hetrixtools",
  intro: "HetrixTools offers uptime, blacklist, and server monitoring with a 1-minute minimum interval. If you need faster checks or a different feature set, these alternatives are worth trying.",
  alternatives: [
    {
      name: "UptimeRobot",
      description: "A widely used uptime monitor with a free plan of 50 monitors at 5-minute checks, now allowed for commercial use. 30-second checks start on the Team plan.",
      pricing: "Free (50 monitors), Solo $10/mo, Team $41/mo",
      pros: ["Free plan with 50 monitors, commercial use allowed", "Mobile apps for iOS and Android", "15-second checks on the Scale plan"],
      cons: ["Free plan checks every 5 minutes; Solo every 60 seconds", "30-second checks start at $41/mo (Team)"],
      url: "https://uptimerobot.com",
    },
    {
      name: "Uptrack",
      description: "Uptime monitoring with 30-second checks, alert confirmation, and browser checks. Pro is $3/mo for 50 monitors.",
      pricing: "Free (5 monitors), Pro $3/mo, Team $20/mo, Business $79/mo",
      pros: ["30-second checks on every plan", "Alerts only after 2-5 consecutive failed checks", "Flat pricing with a 30-day money-back guarantee"],
      cons: ["Free plan is 5 monitors at 30 s from one location", MONITOR_LOCATIONS.alternativesCon, "No APM or logs"],
      url: "https://uptrack.app",
      isUptrack: true,
    },
    {
      name: "Montastic",
      description: "Simple uptime monitoring with a free plan of 50 monitors at 5-minute checks.",
      pricing: "Free (50 monitors), Team $5/mo",
      pros: ["Free plan with 50 monitors", "Status pages on all plans", "Email, SMS, and webhook alerts"],
      cons: ["1-minute minimum interval on paid plans", "Team plan covers 15 monitors"],
      url: "https://montastic.com",
    },
    {
      name: "Pulsetic",
      description: "Status pages and uptime monitoring, with status page custom domains on every plan.",
      pricing: "Free (10 monitors), paid plans from Solo",
      pros: ["Status page custom domains on all plans, including free", "Up to 15 check regions on Team", "SMS, call, and WhatsApp alerts billed per message"],
      cons: ["Free plan checks every 5 minutes", "30-second checks start on the Team plan", "Teammates cost $8/mo each"],
      url: "https://pulsetic.com",
    },
    {
      name: "StatusCake",
      description: "Uptime, page speed, SSL, domain, and server monitoring, with a free plan of 10 monitors.",
      pricing: "Free (10 monitors), Superior $24.49/mo",
      pros: ["Page speed and server monitoring", "9 team members on Superior", "Configurable confirmation servers"],
      cons: ["Free plan checks every 5 minutes", "30-second checks start at $79.99/mo (Business)"],
      url: "https://www.statuscake.com",
    },
  ],
  comparisonTable: [
    { tool: "UptimeRobot", freePlan: "50 monitors", checkInterval: "5min (free), 30s (Team)", alertConfirmation: "Multi-location for timeouts", startingPrice: "$10/mo" },
    { tool: "Uptrack", freePlan: "5 monitors at 30s", checkInterval: "30s (all plans)", alertConfirmation: "Yes (2-5 consecutive)", startingPrice: "Free; Pro $3/mo" },
    { tool: "Montastic", freePlan: "50 monitors", checkInterval: "5min (free), 1min (paid)", alertConfirmation: "Not documented", startingPrice: "$5/mo" },
    { tool: "Pulsetic", freePlan: "10 monitors", checkInterval: "5min (free), 30s (Team)", alertConfirmation: "Not documented", startingPrice: "Solo plan (see site)" },
    { tool: "StatusCake", freePlan: "10 monitors", checkInterval: "5min (free), 30s (Business)", alertConfirmation: "Yes (confirmation servers)", startingPrice: "$24.49/mo" },
  ],
}

export const Route = createFileRoute('/_site/alternatives/hetrixtools')({
  component: () => <AlternativesPage data={data} />,
  head: () => alternativesHead(data),
})
